import axios from 'axios';

import {ApiBadResponseError, readApiModel} from '../../helpers/apiHelpers';
import {CancelError, CancelToken} from '../../helpers/asyncCancelHelpers';
import {ApiIncidentPage} from '../../models/api/incidentPageModel';
import {isAxiosNetworkError, isAxiosTimeoutError} from '../http/httpBase';
import {isFrivolousResponseBody} from '../http/httpHelpers';
import {IncidentsConnector, IncidentsUnavailableError} from './incidentsConnector';

export const statusPageId = 'cd8krl4cl1ks'; // Default status page.
export const partnerStatusPageId = 'jpzlnjpq9t9y'; // Status page used for partner issues.

export class StatusPageIncidents implements IncidentsConnector {
  constructor(pageId = statusPageId) {
    this.url = `https://${pageId}.statuspage.io/api/v2/incidents/unresolved.json`;
  }

  private readonly url: string;

  async fetchIncidentsAsync(cancelToken: CancelToken) {
    const abortController = new AbortController();
    const cancelSubscription = cancelToken.subscribe(() => abortController.abort());
    try {
      const response = await this.fetchStatusPageAsync(abortController.signal);
      return readApiModel(ApiIncidentPage, response.data);
    } catch (error) {
      if (axios.isCancel(error)) {
        throw new CancelError();
      }

      // Ignore HTML responses from proxies/firewalls/etc.
      if (error instanceof ApiBadResponseError && isFrivolousResponseBody(error.body)) {
        throw new IncidentsUnavailableError();
      }

      throw error;
    } finally {
      cancelSubscription.unsubscribe();
    }
  }

  private async fetchStatusPageAsync(signal: AbortSignal) {
    try {
      return await axios.get(this.url, {signal});
    } catch (error) {
      // Ignore network errors.
      if (isAxiosNetworkError(error) || isAxiosTimeoutError(error)) {
        throw new IncidentsUnavailableError();
      }

      throw error;
    }
  }
}
